<template>
  <div style="margin: 10px">
    <v-layout row>
      <v-flex class="sm12 md12">
        <v-toolbar v-if="enabledToolbar" color="primary" dark>
          <v-toolbar-title style="padding-left: 10px">{{ $t(title) }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <!--v-if="accessLevel == 2"-->
            <v-tooltip bottom v-for="(action, index) in actions"
                       v-bind:key="index">
              <template v-slot:activator="{ on }">
                <v-btn
                    fab
                    dark
                    small
                    @click="action.method(selected)"
                    :color="action.color"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>{{ action.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ action.tooltip }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledSearch"
                    fab
                    dark
                    small
                    @click="findItemList()"
                    color="blue-grey"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <span>Search</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledAdd == true"
                    fab
                    dark
                    small
                    @click="addItem()"
                    color="light-blue"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Add</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledSave == true"
                    fab
                    dark
                    small
                    @click="saveItem()"
                    color="primary"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>save</v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledDelete == true"
                    color="error"
                    fab
                    dark
                    small
                    @click="deleteItemList()"
                    @click.stop="confirmDelete = true"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledExcel == true"
                    color="green darken-2"
                    fab
                    dark
                    small
                    @click="downloadExcel()"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>explicit</v-icon>
                </v-btn>
              </template>
              <span>Export to Excel</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="enabledPrint == true"
                    fab
                    dark
                    small
                    @click="doPrintScrn()"
                    color="info"
                    class="elevation-1"
                    v-on="on"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>Print</span>
            </v-tooltip>
          </div>
        </v-toolbar>
        <v-data-table
            fixed-header
            height="300px"
            id="printableArea"
            v-model="selected"
            :headers="fields"
            :items="items"
            v-bind="customProps"
            :pagination.sync="paginationObj"
            :total-items="paginationObj.totalItems"
            :rows-per-page-items="rowsPerPageItems"
            :rows-per-page-text="$t('lang.common.rows_per_page_text')"
            select-all
            :item-key="primaryKey"
            class="elevation-1 gru-table fixed-header"
            :loading="loading"
        >
          <template v-slot:headers="props">
            <tr class="header">
              <th v-if="enabledDelete || enabledCheck" class="no-print">
                <v-checkbox
                    :input-value="props.all"
                    color="primary"
                    hide-details
                    @click.stop="toggleAll"
                ></v-checkbox>
              </th>
              <th
                  v-for="header in colFields"
                  :width="header.width"
                  :key="header.text"
                  :class="[
                  'column sortable',
                  paginationData.descending ? 'desc' : 'asc',
                  header.value === paginationData.sortBy ? 'active' : ''
                ]"
                  @click="changeSort(header.value)"
                  align="left"
              >
                {{ $t(header.text) }}
                <v-icon small class="no-print">arrow_upward</v-icon>
              </th>
            </tr>

            <tr
                class="grey lighten-3 no-print filter"
                v-if="enabledSearch && searchViewType.toUpperCase() === 'INLINE'"
            >
              <td v-if="enabledDelete || enabledCheck" align="left">
                <v-icon>filter_list</v-icon>
              </td>
              <td
                  v-for="header in colFields"
                  :key="header.value"
                  class="text-xs-left gru-filter"
                  :width="header.width"
              >
                <div v-if="!header.ignoreSearch" class="border-and-box">
                  <v-text-field
                      :placeholder="$t('lang.common.input_filter')"
                      single-line
                      hide-details
                      v-on:keyup.enter="findItemList"
                      type="text"
                      flat
                      small
                      v-model="inlineFilters[header.value]"
                      :name="header.value"
                      v-if="header.columnType.toUpperCase() === 'STRING' || header.columnType.toUpperCase() === 'INTEGER' || header.columnType.toUpperCase() === 'LONG'"
                  ></v-text-field>
                  <v-select
                      :placeholder="$t('lang.common.select_filter')"
                      single-line
                      hide-details
                      v-on:change="findItemList"
                      flat
                      small
                      multiple
                      clearable
                      small-chips
                      browser-autocomplete="off"
                      :items="header.optionValues"
                      :item-text="header.itemText"
                      :item-value="header.itemValue"
                      v-model="inlineFilters[header.value]"
                      v-else-if="header.columnType.toUpperCase() === 'SELECT'"
                  ></v-select>
                  <v-select
                      :placeholder="$t('lang.common.select_filter')"
                      single-line
                      hide-details
                      v-on:change="findItemList"
                      flat
                      small
                      clearable
                      small-chips
                      browser-autocomplete="off"
                      :items="header.optionValues"
                      :item-text="header.itemText"
                      :item-value="header.itemValue"
                      v-model="inlineFilters[header.filterColumn]"
                      v-else-if="header.columnType.toUpperCase() === 'COMBOBOX'"
                  ></v-select>
                  <v-select
                      :placeholder="$t('lang.common.select_filter')"
                      single-line
                      hide-details
                      clearable
                      small-chips
                      v-on:change="findItemList"
                      flat
                      small
                      browser-autocomplete="off"
                      :items="header.optionValues"
                      item-text="text"
                      item-value="value"
                      v-model="inlineFilters[header.value]"
                      v-else-if="header.columnType.toUpperCase() === 'BOOLEAN'"
                  ></v-select>
                  <v-daterange
                      :placeholder="$t('lang.common.date_filter')"
                      single-line
                      hide-details
                      v-on:keyup="findItemList"
                      class="v-date-range-box v-text-field"
                      prepend-icon="place"
                      flat
                      small
                      v-model="inlineFilters[header.value]"
                      v-if="header.columnType.toUpperCase() === 'TIMESTAMP'"
                      :preset-label="$t(header.text)"
                      display-format="YYYY-MM-DD"
                      separator-label="~"
                      :key="`${inlineFilters[header.value].start} ${inlineFilters[header.value].end}`"
                  ></v-daterange>
                  <v-daterange
                      :placeholder="$t('lang.common.date_filter')"
                      single-line
                      hide-details
                      class="v-date-range-box v-text-field"
                      v-on:input="findItemList"
                      @submit="findItemList"
                      v-model="inlineFilters[header.value]"
                      v-if="header.columnType.toUpperCase() === 'DATE'"
                      :preset-label="$t(header.text)"
                      display-format="YYYY-MM-DD"
                      separator-label="~"
                      :key="`${inlineFilters[header.value].start} ${inlineFilters[header.value].end}`"

                  ></v-daterange>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
            >
              <td v-if="enabledDelete || enabledCheck" class="no-print">
                <v-checkbox
                    :input-value="props.selected"
                    hide-details
                    color="primary"
                ></v-checkbox>
              </td>
              <td :key="field.id" v-for="field in colFields">
                <div v-if="field.editable">
                  <!--&& accessLevel == 2-->
                  <a
                      href="#"
                      @click.prevent="
                      editItem(props.item[primaryKey], field.editAction)
                    "
                  >
                    <div v-if="field.render">
                      {{ field.render(props.item[field.value], props.item) }}
                    </div>
                    <div v-else-if="field.translatable">
                      {{ props.item[field.value + selectedLocaleIndex] }}
                    </div>
                    <div v-else>
                      <div v-if="field.columnType.toUpperCase() === 'SELECT'">
                        <div v-if="field.optionValues.length > 0">
                          {{ field.optionValues.filter(x => x.value === props.item[field.value])[0].text }}
                        </div>
                        <div v-else>
                          {{ props.item[field.value] }}
                        </div>
                      </div>
                      <div v-else>
                        {{ props.item[field.value] }}
                      </div>
                    </div>
                  </a>
                </div>
                <div v-else>
                  <div v-if="field.render">
                    {{ field.render(props.item[field.value], props.item) }}
                  </div>
                  <div v-else>
                    <div v-if="field.columnType.toUpperCase() === 'SELECT'">
                      <v-layout row justify-start>
                        <div v-if="field.optionValues.length > 0">
                          <div
                              v-for="(s_item, index) in field.optionValues"
                              v-bind:key="index"
                          >
                            <div v-if="s_item.value == props.item[field.value]">
                              {{ s_item.text }}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="field.translatable">
                            {{ props.item[field.value + selectedLocaleIndex] }}
                          </div>
                          <div v-else>
                            {{ props.item[field.value] }}
                          </div>
                        </div>
                      </v-layout>
                    </div>
                    <div
                        v-else-if="field.columnType.toUpperCase() === 'BOOLEAN'"
                        row
                    >
                      <v-layout row justify-center>
                        <v-icon
                            v-if="props.item[field.value]"
                            color="green"
                            class="no-print"
                        >check
                        </v-icon
                        >
                        <v-icon v-if="!props.item[field.value]" class="no-print"
                        >close
                        </v-icon
                        >
                        <!-- <div v-if="field.optionValues && field.optionValues.length>0">
                                                    <div v-for="b_item in field.optionValues" v-if="b_item.value==props.item[field.value]"> {{ b_item.text }}</div>
                                                </div>-->
                      </v-layout>
                    </div>
                    <div v-else-if="field.columnType.toUpperCase() === 'DATE'">
                      <v-layout row justify-start>
                        {{ formatDate(props.item[field.value]) }}
                      </v-layout>
                    </div>
                    <div
                        v-else-if="field.columnType.toUpperCase() === 'TIMESTAMP'"
                    >
                      <v-layout row justify-start>
                        {{ formatDate(props.item[field.value]) }}
                      </v-layout>
                    </div>
                    <div
                        v-else-if="field.columnType.toUpperCase() === 'ICON' && ((field.displayCondition == undefined) || (field.displayCondition != undefined && field.displayCondition(props.item)))"
                        style="text-align: center"
                    >
                      <v-btn
                          depressed
                          outline
                          icon
                          fab
                          dark
                          :color="field.color"
                          small
                          @click="field.method(props.item)"
                      >
                        <v-icon>{{ field.icon }}</v-icon>
                      </v-btn>
                    </div>
                    <div v-else-if="field.icon">
                      <v-layout v-if="props.item[field.value] && props.item[field.value].includes('http')">
                        <img :src="props.item[field.value]" :width="props.item[field.size]" alt=""/>
                      </v-layout>
                      <v-layout v-else>
                        <v-icon :color="props.item[field.color]" :size="props.item[field.size]">
                          {{ props.item[field.value] }}
                        </v-icon>
                      </v-layout>

                      <span v-if="field.showLabel"> ({{ props.item[field.value] }})</span>
                    </div>
                    <div v-else>
                      <div v-if="field.translatable">
                        {{ props.item[field.value + selectedLocaleIndex] }}
                      </div>
                      <div v-else-if="field.truncate">
                        {{ truncateText(props.item[field.value], field.length) }}
                      </div>
                      <div v-else>
                        {{ props.item[field.value] }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog
            v-model="confirmDelete"
            max-width="290"
        >
          <v-card>
            <v-card-title class="headline">{{ this.$t("lang.common.sure") }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                  v-if="this.$store.state.auth.accessLevel == 2"
                  dark color="primary"
                  @click="confirmDelete = false; isDel = false;"
              >
                Cancel
              </v-btn>
              <v-btn
                  dark color="primary"
                  @click="confirmDelete = false; isDel = true;"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--v-dialog v-model="showTopology" max-width="80%" transition="dialog-bottom-transition" overlay=false scrollable>
          <gru-topology @onLeafNodeClicked="changeRootNode" :nodeCode="nodeCode" :itemValue="itemValue"
                        ref="topologyGraph"></gru-topology>
        </v-dialog-->
        <!-- <v-flex class="text-xs-left sm4 md4 align-left">
          <v-btn color="primary" v-if="showResetBtn" @click="resetFilters" fab small dark class="elevation-1"><v-icon>autorenew</v-icon></v-btn>
        </v-flex> -->
        <!-- <init-query-builder :fields="fields" @update-query="findItemList" v-if="enabledSearch && searchViewType.toUpperCase() === 'QUERY_BUILDER'"></init-query-builder>-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {router} from "../router";
import {CrudService} from "@/services/crud.service";
import {message} from "@/shared/message";
import {VDaterange} from "vuetify-daterange-picker";
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";
import {mapGetters} from "vuex";
import {printScrn} from "../shared/utils";
import {menuService} from "@/services";


export default {
  name: "gru-table",
  components: {VDaterange},
  inheritAttrs: false,
  props: {
    resource: {
      type: String,
      default: () => ""
    },
    resource_title: {
      type: String,
      default: () => ""
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    defaultData: {
      type: Object,
      default: () => ({
        content: []
      })
    },
    primaryKey: {
      type: String,
      default: () => "id"
    },
    enabledToolbar: {
      type: Boolean,
      default: () => true
    },
    enabledSearch: {
      type: Boolean,
      default: () => true
    },
    enabledAdd: {
      type: Boolean,
      default: () => true
    },
    enabledSave: {
      type: Boolean,
      default: () => false
    },
    enabledDelete: {
      type: Boolean,
      default: () => true
    },
    enabledCheck: {
      type: Boolean,
      default: () => false
    },
    enabledExcel: {
      type: Boolean,
      default: () => true
    },
    enabledPrint: {
      type: Boolean,
      default: () => true
    },
    enabledPagination: {
      type: Boolean,
      default: () => true
    },
    pagination: {
      type: Object,
      default: () => ({
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "",
        totalItems: 0,
        rowsPerPageItems: [10, 20, 100, 1000],
        paging: true
      })
    },
    dateSearchType: {
      type: String,
      default: () => "RANGE"
    },
    searchViewType: {
      type: String,
      default: () => "INLINE"
    },
    disableLoadData: {
      type: Boolean,
      default: () => false
    },
    resourceAction: {
      type: String,
      default: () => ""
    },
    handleAdd: Function,
    handleEdit: Function,
    handleSave: Function,
    handleDelete: Function,
    hiddenC: {
      type: Array,
      // default: () => [],
      default: function () {
        return this.fields.filter(x => x.columnType === 'DATE').map(a => {
          return {
            columnName: a.value,
            columnType: a.columnType,
            value: ',',
          }
        })
      }
    },
    actions: {
      type: Array,
      default: () => []
    },
    //actions: ()=>[]
  },
  data: function () {
    return {
      loading: true,
      confirmDelete: false,
      isDel: false,
      showTopology: false,
      data: this.defaultData,
      paginationData: this.pagination,
      rowsPerPageItems: [10, 25, 50, 100, 1000],
      searchQuery: {
        product: "",
        queryRule: "",
        isExcel: false,
        hiddenConditions: this.hiddenC,
        tableFieldList: [],
        sqlQuery: "",
        tableName: ""
      },
      allowLoadData: !this.disableLoadData,
      selected: [],
      inlineFilters: {},
      parentResources: {},
      defaultConditions: [],
      loaded: false,
      showResetBtn: false,
      ignoreValues: [],
      nodeCode: null,
      itemValue: null,
      dateloaded: false,
    };
  },
  watch: {
    data: function () {
      this.loading = false;
    },
    selected: function () {
      this.$emit("tableSelect", this.selected)
    },
    $route() {
      //console.log("hello");
    }
  },
  computed: {
    items: function () {
      return this.data.content;
    },
    paginationObj: {
      get: function () {
        return this.paginationData;
      },
      set: function (value) {
        this.paginationData = value;
        if (this.allowLoadData) {
          this.getItemList();
        }
      }
    },
    colFields: function () {
      var colFields = this.fields.filter(function (f) {
        return !f.ignoreGUI;
      });

      colFields = colFields.map(function (f) {
        if (!f.columnType) {
          f.columnType = "STRING";
        }
        if (f.columnType.toUpperCase() === "SELECT") {
          if (!f.itemText) {
            f.itemText = "text";
          }
          if (!f.itemValue) {
            f.itemValue = "value";
          }
        }

        return f;
      });
      return colFields;
    },
    excelFields: function () {
      let vm = this;
      return this.fields.filter(function (f) {
        f.text = vm.$t(f.text);
        return !f.ignoreExcel;
      });
    },
    searchFields: function () {
      return this.fields.filter(function (f) {
        return (
            !f.ignoreSearch &&
            f.columnType != "DATE" &&
            f.columnType != "TIMESTAMP"
        );
      });
    },
    dateSearchFields: function () {
      return this.fields.filter(function (f) {
        return (
            !f.ignoreSearch &&
            (f.columnType == "DATE" || f.columnType == "TIMESTAMP")
        );
      });
    },
    customProps: function () {
      if (!this.enabledPagination) {
        return {
          "hide-actions": true
        };
      }
    },
    accessLevel() {
      return this.$store.state.auth.accessLevel;
    },
    ...mapGetters(["selectedLocaleIndex"]),
    ...mapGetters("menu", ["menuTree"]),
    title: function () {
      let title = "";
      this.menuTree.forEach(item => {
        if (item.href == "") {
          let grandChild = null;
          if (item.items == null) {
            let a = 1;
          }
          let child = item.items.find(i => {
            //return i.component === this.$route.name;
            if (i.href == "" && i.items) {
              grandChild = i.items.find(grandItem => {
                return menuService.isMatched(grandItem.href, this.$route.path);
              });
              if (grandChild) {
                return true;
              }
              return false;
            } else {
              return menuService.isMatched(i.href, this.$route.path);
            }
          });
          if (child) {
            title = this.$i18n.t(child.title);
          }
          if (grandChild) {
            title = this.$i18n.t(grandChild.title);
          }
        } else {
          if (menuService.isMatched(item.href, this.$route.path)) {
            title = this.$i18n.t(item.title);
          }
        }
      });
      return title;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.slice();
    },

    resetFilters() {
      Object.keys(this.inlineFilters).forEach(k => {
        this.inlineFilters[k] = ""
      });
      this.findItemList();
      this.showResetBtn = false;
    },

    changeSort(column) {
      if (this.paginationObj.sortBy === column) {
        this.paginationObj.descending = !this.paginationObj.descending;
      } else {
        this.paginationObj.sortBy = column;
        this.paginationObj.descending = false;
      }
      this.findItemList();
    },

    getItemList() {
      let user = this.$store.state.auth.user.userId;

      const domain = window.location.hostname;
      const product = domain.includes("lms-edusmart.")
        ? "EDUSMART"
        : "BABILALA";

      if (sessionStorage.userSearch && this.loaded === false) {

        let ls = JSON.parse(localStorage.user);
        let ss = JSON.parse(sessionStorage.userSearch);
        if (ss[user].hasOwnProperty("collection-table-search")) {
          delete ss[user]["collection-table-search"];
        }
        if (ss.hasOwnProperty(ls.userId)) {
          if (ss[user].hasOwnProperty(this.resource)) {
            this.searchQuery = ss[user][this.resource]
          }
        }
        this.loaded = true;
      }

      this.searchQuery.product = product;

      return CrudService.of(this.resource)
          .getList(this.paginationData, this.searchQuery, this.resourceAction)
          .then(data => {
            if (data !== undefined) {
              this.selected = [];
              this.data = data;
              this.paginationData.totalItems = data.totalElements;
            }
            return data;
          });
    },

    setItemList(data) {
      this.data = {content: data};
    },

    setParentResources(data) {
      this.parentResources = data;
    },

    setDefaultConditions(data) {
      this.defaultConditions = data;
      this.findItemList();
      this.allowLoadData = true;
    },

    addItem() {
      if (this.handleAdd) {
        return this.handleAdd();
      }
      if (this.parentResources && this.parentResources.length > 0) {
        let v = "";
        for (let i = 0; i < this.parentResources.length; i++) {
          let r = this.parentResources[i];
          v += "/" + r.key;
          if (r.value) {
            v += "/" + r.value;
          }
        }
        let path = `` + v + `/` + this.resource + `/` + `edit`;
        //console.log("add path = " + path);
        router.push(path);
      } else {
        router.push(`/${this.resource}/edit/`);
      }
    },

    editItem(id, editAction) {
      if (this.handleEdit) {
        return this.handleEdit(id, editAction);
      }
      if (this.parentResources && this.parentResources.length > 0) {
        let v = "";
        for (let i = 0; i < this.parentResources.length; i++) {
          let r = this.parentResources[i];
          v += "/" + r.key;
          if (r.value) {
            v += "/" + r.value;
          }
        }
        let path =
            `` +
            v +
            `/` +
            this.resource +
            `/` +
            (editAction ? editAction : `edit`) +
            `/` +
            id;
        //console.log("edit path = " + path);
        router.push(path);
      } else {
        router.push(
            `/${this.resource}` +
            `/` +
            (editAction ? editAction : `edit`) +
            `/` +
            id
        );
      }
    },

    changeRootNode(payload) {
      let {nodeCode, itemValue} = payload;
      this.nodeCode = nodeCode;
      this.itemValue = itemValue;
      this.showTopology = true;
    },
    openTopology(nodeCode, itemValue) {
      this.nodeCode = nodeCode;
      this.itemValue = itemValue;
      this.showTopology = true;
    },

    isEnableTopology(value) {
      if (this.ignoreValues !== undefined && this.ignoreValues.length > 0) {
        if (this.ignoreValues.includes(value)) {
          return false;
        }
      }

      return true;

    },

    closeTopology() {
      this.nodeCode = null;
      this.itemValue = null;
      this.showTopology = false;
    },

    deleteItem(id) {
      if (confirm(this.$t("lang.common.sure"))) {
        return CrudService.of(this.resource)
            .deleteItem(id)
            .then(() => {
              message.success(
                  this.$t("lang.common.deleted", {msg: `${this.resource_title}`})
              );
              this.getItemList();
            });
      }
    },

    saveItem() {
      this.$emit("apply", this.selected);
      /*
      if(this.handleSave){
          //console.log("---- selected item ---");
          //console.log(this.selectedItem);
          //console.log("---- selected ---");
          //console.log(this.selected);
          return this.handleSave(this.selected);
      }
      */
    },

    deleteItemList() {
      //debugger;
      if (this.selected && this.selected.length > 0) {
        //console.log(this.selected);
        if (confirm(this.$t("lang.common.sure"))) {
          let id_name = this.primaryKey;
          var ids = [];
          this.selected.forEach(function (selectedItem) {
            if (selectedItem[id_name] != undefined) {
              ids.push(selectedItem[id_name]);
            }
          });
          if (this.handleDelete) {
            return this.handleDelete(ids);
          } else {
            return CrudService.of(this.resource)
                .deleteItemList(ids)
                .then(response => {
                  //debugger;
                  message.success(
                      this.$t("lang.common.deleted", {
                        msg: this.$t(`${this.resource_title}`)
                      })
                  );
                  this.getItemList();
                  this.$emit("delete-item-in-table", this.selected.length);
                  this.selected = [];
                  return ids;
                })
                .catch(error => {
                  // Failed
                  //debugger;
                  message.error("The item couldn't be deleted!");
                });
          }
        }
      } else {
        alert(this.$t("lang.common.select_one")); //"Please select at least one item"
      }
    },

    buildSearchQuery() {
      if (this.defaultConditions.length > 0) {
        this.searchQuery.hiddenConditions = this.defaultConditions;
      } else {
        this.searchQuery.hiddenConditions = this.hiddenC;
      }
      for (let key in this.inlineFilters) {
        //console.log("key=" + key);
        let columnType = "";
        let filterColumn = key;
        this.colFields.forEach(function (field) {
          if (
              field["columnType"] &&
              (field["value"] == key || field["filterColumn"] == key)
          ) {
            columnType = field["columnType"];
            if (field["filterColumn"]) {
              filterColumn = field["filterColumn"];
            }
          }
        });
        if (!columnType) {
          columnType = "STRING";
        }
        var value = "";
        if (columnType.toUpperCase() === "SELECT") {
          if (this.inlineFilters[key] && this.inlineFilters[key].length > 0) {
            value = this.inlineFilters[key].join();
          }
        } else if (columnType.toUpperCase() === "COMBOBOX") {
          if (this.inlineFilters[key] != null) {
            value = this.inlineFilters[key];
          }
        } else if (columnType.toUpperCase() === "BOOLEAN") {
          if (this.inlineFilters[key] != null) {
            value = this.inlineFilters[key];
          }
        } else if (
            columnType.toUpperCase() === "DATE" ||
            columnType.toUpperCase() === "TIMESTAMP"
        ) {
          if (this.inlineFilters[key]) {
            value =
                this.inlineFilters[key].start + "," + this.inlineFilters[key].end;
          }
        } else {
          if (this.inlineFilters[key]) {
            value = this.inlineFilters[key];
          }
        }
        this.searchQuery.hiddenConditions.push({
          columnName: filterColumn,
          value: value,
          columnType: columnType
        });
      }

      this.searchQuery.hiddenConditions = this.optimizeFilter(this.searchQuery.hiddenConditions);
      let p = this.$store.getters.getSqlQuery;
      if (p) {
        this.searchQuery.sqlQuery = p.listSql;
        this.searchQuery.tableName = p.tableName;
      }
      this.searchQuery.queryRule = this.$store.getters.getSQLStatement;
      if (this.searchQuery.queryRule.trim().toUpperCase() === "AND") {
        this.searchQuery.queryRule = "";
      }
    },

    optimizeFilter(array) {
      let column_list = array.map(x => x.columnName);
      let column_list_distinct = [...new Set(column_list)];
      let new_array = [];
      for (let i = array.length - 1; i >= 0; i--) {
        if (column_list_distinct.includes(array[i].columnName) && new_array.length < column_list_distinct.length) {
          new_array.push(array[i]);
        }
      }
      let final_array = [];
      for (let i = 0; i < new_array.length; i++) {
        if (new_array[i].value !== "") {
          final_array.push(new_array[i]);
        }
      }
      return final_array
    },

    findItemList() {
      let user = this.$store.state.auth.user.userId;
      this.showResetBtn = true;
      this.buildSearchQuery();
      this.getItemList();
      let newSS = JSON.parse(sessionStorage["userSearch"]);
      if (newSS[user].hasOwnProperty("collection-table-search")) {
        delete newSS[user]["collection-table-search"];
      }
      newSS[user][this.resource] = this.searchQuery;
      sessionStorage["userSearch"] = JSON.stringify(newSS);
      this.allowLoadData = true;
      this.showResetBtn = newSS[user][this.resource].hiddenConditions.length > 0;
    },

    downloadExcel() {
      this.buildSearchQuery();
      this.searchQuery.tableFieldList = this.excelFields;
      return CrudService.of(this.resource).downloadExcel(
          this.paginationData,
          this.searchQuery
      );
    },

    formatDate: function (date) {
      return date;
    },

    doPrintScrn() {
      printScrn();
    },
    truncateText: function (text, length) {
      if (length === undefined) {
        length = 99;
      }
      if (text && text.length > length) {
        return text.substring(0, length - 1) + "...";
      }
      return text;

    }
  },
  created: function () {
    let user = this.$store.state.auth.user.userId;
    this.$store.dispatch("resetQueryBuilder");
    try {
      JSON.parse(sessionStorage.userSearch);
    } catch (e) {
      sessionStorage.setItem("userSearch", JSON.stringify({
        [user]: null,
      }));
    }
    let ss = JSON.parse(sessionStorage.userSearch);
    if (ss[user]) {
      sessionStorage.setItem("userSearch", JSON.stringify({
        ...ss,
        [user]: ss[user]
      }));
      if (!ss[user][this.resource]) {
        let ss = JSON.parse(sessionStorage.userSearch);
        ss[user][this.resource] = this.searchQuery;
        sessionStorage.setItem("userSearch", JSON.stringify({
          ...ss,
        }));
      }
    } else {
      sessionStorage.setItem("userSearch", JSON.stringify({
        ...ss,
        [user]: {[this.resource]: this.searchQuery}
      }));
    }
    ss = JSON.parse(sessionStorage.userSearch);
    if (ss[user].hasOwnProperty("collection-table-search")) {
      delete ss[user]["collection-table-search"];
    }
    if (ss[user].hasOwnProperty(this.resource)) {
      this.showResetBtn = ss[user][this.resource].hiddenConditions.length > 0;
      ss[user][this.resource].hiddenConditions.forEach(x => {
        this.inlineFilters[x.columnName] = x.value;
        if (x.columnType === "SELECT") {
          this.inlineFilters[x.columnName] = x.value.includes(",")
              ? x.value.split(",").map(y => {
                if (Number.isNaN(Number(y))) {
                  return String(y)
                } else {
                  return Number(y)
                }
              })
              : [Number.isNaN(Number(x.value)) ? String(x.value) : Number(x.value)];
        } else if (x.columnType.toUpperCase() === "DATE") {
          //console.log("DDDDAAATTTEEEEE");
          this.inlineFilters[x.columnName] = x.value.split(',').reduce((a, b) => {
            return {
              start: a,
              end: b
            }
          })
        } else {
          this.inlineFilters[x.columnName] = x.value;
        }
      })
    }

    if (this.$config.setting.pagination) {
      this.paginationData.rowsPerPage = parseInt(this.$config.setting.pagination.row_per_page);
    }

  },
  mounted() {
    var vm = this;
    this.$root.$on("gruTableSearch", function () {
      vm.findItemList();
    });
  },

};
</script>

<style>
.border-and-box {
  font-size: 70%;
}

.gru-table .gru-filter {
  max-width: 316px;
}

.gru-table .v-datatable thead tr.header {
  background: #eee;
  height: 39px;
}

.gru-table .v-datatable thead tr.filter {
  height: 46px;
}

.gru-table .v-datatable thead th {
  padding: 0 16px;
}

.gru-table .v-datatable thead td {
  border-left: 1px solid #ccc;
}

.gru-table .v-datatable tbody td:not(:first-child) {
  border-left: 1px solid #ccc;
}

.gru-table .gru-filter .v-text-field {
  padding-top: 0;
  margin-top: 0;
}

.gru-table .gru-filter .v-text-field input {
  font-size: 12px !important;
  padding: 0 !important;
  min-height: 32px;
}

.gru-table .gru-filter .v-text-field .v-input__slot {
  margin-bottom: 0;
}

.gru-table .gru-filter .v-text-field .v-text-field__details {
  display: none;
}

@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>
